import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";

function TVShowSeasonEpisode() {
  const { seasonIdparams } = useParams();
  const { token } = isAutheticated();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [episode, setEpisode] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/api/tvshow/view_season/${seasonIdparams}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setEpisode(response.data?.episode || []);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [seasonIdparams, success]);

  // Calculate total pages
  const totalPages = Math.ceil(episode.length / itemsPerPage);

  // Get the items for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = episode.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page on items per page change
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Content Management - TV Shows - Seasons</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">Episodes</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Episodes Table */}
          <div className="card">
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>
                    Show
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm ml-2"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>{" "}
                    entries
                  </label>
                </div>
                <div className="col-md-6 text-right">
                  <Link to={`/season/episode/add/${seasonIdparams}`}>
                    <button className="btn btn-primary">
                      <i className="fa fa-plus"></i> Add New Episode
                    </button>
                  </Link>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th>Video</th>
                      <th>Episode</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="3" className="text-center">
                          <strong>Loading...</strong>
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((data) => (
                        <tr key={data._id}>
                          <td>
                            <video width="67" height="50" controls>
                              <source src={data?.lesson_id?.video} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </td>
                          <td>Episode {data.episodeNumber}</td>
                          <td>
                            <button
                              onClick={() => {
                                if (window.confirm("Do you want to delete?")) {
                                  axios
                                    .delete(`${API}/api/tvshow/delete_episode/${seasonIdparams}/${data._id}`, {
                                      headers: { Authorization: `Bearer ${token}` },
                                    })
                                    .then(() => {
                                      swal("Deleted!", "Episode has been deleted.", "success");
                                      setSuccess(!success);
                                    })
                                    .catch((err) => console.error(err));
                                }
                              }}
                              className="btn btn-danger btn-sm"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No episodes found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="row mt-4">
                <div className="col-md-6">
                  <p>
                    Showing {indexOfFirstItem + 1} to{" "}
                    {Math.min(indexOfLastItem, episode.length)} of {episode.length} entries
                  </p>
                </div>
                <div className="col-md-6 text-right">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                        Previous
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => (
                      <li
                        key={i}
                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                      >
                        <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TVShowSeasonEpisode;
